import { GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_EXPANDED_WIDTH, GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH } from 'nav-meta/constants';
import { queryLocalStorage } from '../../utils/localstorage';
export function getIsVerticalNavInitiallyCollapsed() {
  if (queryLocalStorage('VERTICAL_NAV_COLLAPSED') === null) {
    return true;
  }
  return queryLocalStorage('VERTICAL_NAV_COLLAPSED') === true;
}
export function getNavWidthFromNavConfig(navConfigResponse) {
  if ('portal' in navConfigResponse) {
    return getIsVerticalNavInitiallyCollapsed() ? parseInt(GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH, 10) : parseInt(GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_EXPANDED_WIDTH, 10);
  }

  // hubless nav
  return 0;
}